// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Filter } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconFilter(props: any) {
    return <IconBase icon={Filter} {...props} />
  }

  export default IconFilter
  